export const EXTRA_TYPE: any = {
  openfile: 'openfile',
  additionaltools: 'additionaltools',
  todolist: 'todolist',
  imageeditor: 'imageeditor',
  database: 'database',
  configuration: 'configuration',
  claire: 'claire'
}

export const EXTRA_TYPE_TITLE: any = {
  openfile: 'WORKSPACE_OPEN_FILE_TITLE',
  additionaltools: 'WORKSPACE_ADDITIONAL_TOOLS_TITLE',
  todolist: 'WORKSPACE_TODO_LIST_TITLE',
  imageeditor: 'WORKSPACE_IMAGE_EDITOR_TITLE',
  database: 'WORKSPACE_DATABASE_TITLE',
  configuration: 'WORKSPACE_CONFIGURATION_TITLE',
  claire: 'CLAIRE'
}

export const EXTRA_TITLE_ICON: any = {
  openfile: '',
  additionaltools: '',
  todolist: '', //event_list
  imageeditor: '',
  database: '',
  configuration: '',
  claire: ''
}

export const EXTRA_TITLE_IMAGE_DARK: any = {
  openfile: '',
  additionaltools: '',
  todolist: '', //event_list
  imageeditor: '',
  database: '',
  configuration: '',
  claire: "assets/claire-logo-dark.svg"
}

export const EXTRA_TITLE_IMAGE_LIGHT: any = {
  openfile: '',
  additionaltools: '',
  todolist: '', //event_list
  imageeditor: '',
  database: '',
  configuration: '',
  claire: "assets/claire-logo-light.svg"
}